/**
 * Checks if a specific cookie exists and optionally matches a value.
 *
 * @param name - Cookie name to check
 * @param expectedValue - Optional: value to match against
 * @returns true if cookie exists (and matches value if provided)
 */
export function hasCookieProperty(name: string, expectedValue?: string): boolean {
  if (typeof document === 'undefined') return false;

  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const [rawKey, rawValue] = cookie.split('=');
    const key = rawKey.trim();
    const value = rawValue?.trim();

    if (key === name) {
      return expectedValue ? value === expectedValue : true;
    }
  }

  return false;
}
